import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';
import { SheetContent } from 'Src/shared/BottomSheet/styles';
import { SwipeableBottomDrawer } from 'Src/shared/BottomSheet/SwipeableBottomDrawer';
import { MapProviderCardList } from '@kyruus/provider-components';

export const MapCardMobileWrapper = styled.div`
  position: absolute;
  bottom: 0px;
  margin-bottom: 100px;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const ProviderListWrapper = styled.div`
  margin: 0 ${fromTheme('spacing_large')};
`;

export const SortControlContainer = styled.div`
  text-align: center;
  padding-bottom: ${fromTheme('spacing_medium')};
`;

export const MapProviderCardListSheetContent = styled(SheetContent)`
  height: fit-content;
  max-height: 100%;
`;

export const StyledSwipeableDrawer = styled(SwipeableBottomDrawer)`
  & .MuiPaper-root {
    height: fit-content;
    max-height: 75%;
    > div {
      background: ${fromTheme('color_background')};
    }
  }
`;

export const StyledMapProviderCardList = styled(MapProviderCardList)`
  border: none;
`;
